export default __webpack_public_path__ + "static/media/rr.19188c0c.png";